import styles from './hierarhy-levels.module.scss'
import { Button, H2, IconExpand, Input, SectionContainer, Select } from "@touche-lts/panel-ui/dist"
import { useRootStore } from "mobx-stores/store-provider"
import { observer } from 'mobx-react-lite'
import { DepartmentSubcategory, DepartmentType } from 'models/departments'
import cl from 'classnames'
import { Table } from 'react-bootstrap'
import { InputTags } from 'react-bootstrap-tagsinput'

const CategoryHierarhyLevelsPageComponent = (props) => { //TODO-A To add a model

  const {
    departmentsStore: {
      departmentCategory,
      setSubcategoryName,
      addSubcategory,
      addType,
      parentSubcategory,
      subcategoryExist,
      setSubtypeName,
      setParentSubcategory,
      setTypesForCategory
    }
  } = useRootStore()

  return (
    <SectionContainer
      extraPaddingBottom
    >
      <H2>
      Hierarchy levels
      </H2>
      <div className={styles.strongOptional}>
        <p>Subcategories</p>
        <span>(Optional)</span>
      </div>
      {departmentCategory?.subcategories?.map((subcategory: DepartmentSubcategory, subcategoryIndex: number) => {
        return (
          <Input
            colorPreset='dark'
            placeholder='Add subcategory name'
            value={subcategory.name}
            className={cl(styles.inputHierarhy, 'mt-3')}
            key={subcategoryIndex}
            onChange={name => setSubcategoryName(name, subcategoryIndex)}
          />
        )
      })}
      <Button
        className='pb-3'
        preset='link'
        style={{ marginTop: 30 }}
        onClick={() => addSubcategory()}
      >
        <IconExpand style={{ marginRight: 8, fill: styles.primary }} />
        Add{subcategoryExist && ' another'} subcategory
      </Button>


      {subcategoryExist && (
        <>
          <hr />
          <Table className={styles.tableTypes} borderless>
            <tbody>
              <tr className={styles.tableHeaders}>
                <td className={styles.typeSubcategory}>Type</td>
                <td className={styles.typeSubcategory}>Parent Subcategory</td>
                <td>Subtype <span>(Optional)</span></td>
              </tr>
              {departmentCategory?.types.map((typeGroup: DepartmentType, indexTypeGroup: number) => {
                return (
                  <tr>
                    <td className={styles.typeSubcategory}>
                      <Input
                        placeholder='Add type'
                        value={typeGroup.name}
                        className={cl(styles.inputHierarhy, 'mt-1')}
                        key={indexTypeGroup}
                        onChange={name => setSubtypeName(name, indexTypeGroup)}
                      />
                    </td>
                    <td className={styles.typeSubcategory}>
                      <Select
                        options={parentSubcategory}
                        noNoneOption
                        value={typeGroup?.parentSubcategoryName}
                        className={styles.selectParentSubcategory}
                        key={indexTypeGroup}
                        onChange={parentSubcategory =>
                          setParentSubcategory(parentSubcategory, indexTypeGroup)
                        }
                      />
                    </td>
                    <td>
                      <div className={styles.inputTagsStyle}>
                        <InputTags
                          values={typeGroup?.subtypes.map(type => type.name)}
                          onTags={(value) => setTypesForCategory(value.values, indexTypeGroup)}
                        />
                      </div>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </Table>

          <Button
            preset='link'
            style={{ marginTop: 30 }}
            onClick={() => addType()}
          >
            <IconExpand style={{ marginRight: 8, fill: styles.primary }} />
            Add{!!departmentCategory?.types?.length && ' another'} type
          </Button>
        </>
      )}

    </SectionContainer>
  )
},

  CategoryHierarhyLevelsPage = observer(CategoryHierarhyLevelsPageComponent)
export { CategoryHierarhyLevelsPage }
